import script from "./AssessmentStaffCoverage.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentStaffCoverage.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentStaffCoverage.vue?vue&type=style&index=0&id=6f06b92a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f06b92a"]])

export default __exports__